import { type Dialog } from '../models';
import { dialogsSelector } from './dialogs';

export const dialogSelectorFactory =
    (id: string) =>
    (state: GlobalState): Dialog | undefined =>
        dialogsSelector(state)[id];
